
























































































import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import { VbDirectives } from '@/shared/directive/vb-directives';
import splitContent from '@/shared/directive/split-content';
import EnumObject from '@/domain/enum-object.entity';
import DateFormat from '@/shared/utils/date-format';
import JustifyPersist from '@/domain/justify/domain/justify-persist.entity';
import DatePickerMonthYear from '@/shared/date-picker/date-picker-month-year.component.vue';
import { VMoney } from 'v-money';
import { JustifyType } from '@/domain/justify/domain/justify-type.enum';
import Rules from '@/shared/rules/rules';
import JustifyModal from '@/shared/modal/justify-modal.component.vue';
import DiscountItemRuleRequest from '@/domain/contract/request/discount-item-rule-request.entity';
import ContractDiscount from '@/domain/contract/request/contract-discount.entity';
import MainButton from '@/shared/buttons/main-button.component.vue';
import Strategies from './discount-strategy.json';
import Types from './discount-type.json';
import Contract from '../../../../domain/contract/entity/contract.entity';
import ContractService from '../../../../domain/contract/service/contract.service';
import EditModeButton from '../fees-and-discounts-commons/edit-mode-button.component.vue';
import StrategyRadio from '../fees-and-discounts-commons/strategy-radio.component.vue';
import FeeDiscountTypeSelect from '../fees-and-discounts-commons/fee-discount-type-select.component.vue';
import FeeDiscountCompetences from '../fees-and-discounts-commons/fee-discount-competences.component.vue';
import FeeDiscountTable from '../fees-and-discounts-commons/fee-discount-table.component.vue';

@Component({
  filters: {
    monthYear(value: string): string {
      const date: string = DateFormat.localDateToLocal(value);
      return DateFormat.fullMonthAndYear(date);
    },
    splitContent,
    toCurrency: VbDirectives.toCurrency,
  },
  directives: {
    money: VMoney,
  },
  components: {
    VbTooltipSlot,
    DatePickerMonthYear,
    MainButton,
    JustifyModal,
    EditModeButton,
    StrategyRadio,
    FeeDiscountTypeSelect,
    FeeDiscountCompetences,
    FeeDiscountTable,
  },
})
export default class DiscountComponent extends Vue {
  @Prop({
    required: true,
  })
  contract!: Contract;

  @Prop({
    required: true,
  })
  businessUnitId!: string;

  @Prop({
    required: true,
  })
  isEditable!: boolean;

  @Prop({ type: Boolean, default: false }) isAdministratorOrSupervisorOrGp!: boolean;

  @Prop() isAdministrator!: boolean;

  @Prop() isSupervisor!: boolean;

  strategies: EnumObject[] = EnumObject.ofList(Strategies);

  types: EnumObject[] = EnumObject.ofList(Types);

  validationRules: Rules = new Rules();

  rules: any[] = [...this.contract.currentVersion!!.discountItemRules];

  selectedDiscountType: string = this.contract.discountType.value;

  periodStart: string = this.contract.periodStart;

  periodEnd: string = this.contract.periodEnd;

  editModeValue: boolean = false;

  ref: any = this.$refs;

  showJustityModal: boolean = false;

  justifyModalKey: number = 0;

  justifyType: JustifyType = JustifyType.CONTRACT_BILLING_DISCOUNT;

  created() {
    this.applyValues();
  }

  updateJustifyModalKey(value: boolean) {
    this.justifyModalKey += 1;
    this.showJustityModal = value;
  }

  get disableRuleSelection(): boolean {
    if (!this.editModeValue) return true;
    return this.contract.applyAllDiscountStrategy || this.contract.notApplyDiscountStrategy;
  }

  get disableDiscountValueConfig(): boolean {
    if (!this.editModeValue) return true;
    return this.contract.notApplyDiscountStrategy;
  }

  get editMode(): object {
    return {
      color: this.editModeValue ? 'lightGreen' : 'lightBlue',
      text: this.editModeValue ? 'Editando' : 'Editar',
      icon: !this.editModeValue,
    }
  }

  setDiscountStrategy(value: string) {
    this.$emit('updateDiscountStrategyValue', this.createMatchingEnumObject(value));
  }

  setDiscountStrategyAndApplyRules(value: string) {
    this.setDiscountStrategy(value);
    this.applyDiscountFlagValueOnRules();
  }

  createMatchingEnumObject(value: string): EnumObject {
    let arrayPos: number = 0;
    if (value === 'APPLY_ALL') arrayPos = 1;
    if (value === 'CUSTOM') arrayPos = 2;
    return EnumObject.of(this.strategies[arrayPos]);
  }

  applyValues(): void {
    this.setDiscountStrategy(this.contract.discountStrategy.value);
    this.applyDiscountSelectedTypeOnRules();
  }

  applyDiscountSelectedTypeOnRules(): void {
    this.rules.forEach((rule) => rule.discountType = this.selectedDiscountType);
  }

  applyDiscountFlagValueOnRules(): void {
    if (this.contract.discountStrategy.value === 'APPLY_ALL') {
      this.rules.forEach((rule) => rule.applyDiscount = true);
      this.changeValue(this.rules[0].discount);
    }

    if (this.contract.discountStrategy.value === 'NOT_APPLY') {
      this.rules.forEach((rule) => rule.applyDiscount = false);
      this.applyDiscountValueForAllRules(0);
      this.rerenderTextFields();
    }
  }

  setRuleSelection({ value, index }: any): void {
    this.rules[index].applyDiscount = value;
  }

  setFeeValue({ value, index }: any): void {
    this.rules[index].discount = value;
  }

  changeValue(value: any): void {
    if (this.contract.discountStrategy.value === 'APPLY_ALL') {
      this.applyDiscountValueForAllRules(value);
    }
    this.rerenderTextFields();
  }

  applyDiscountValueForAllRules(value: any): void {
    this.rules.forEach((rule) => rule.discount = value);
  }

  get isSelectionDisabled(): boolean {
    return !this.editModeValue
      || this.contract.notApplyDiscountStrategy
      || this.contract.applyAllDiscountStrategy;
  }

  rerenderTextFields(): void {
    const { discountTable }: any = this.$refs;
    discountTable.rerenderTextFields();
  }

  validate(): boolean {
    return this.ref.form.validate();
  }

  clickSave(): void {
    if (this.validate()) {
      this.showJustityModal = true;
    }
  }

  persistDiscount(values): void {
    const justify: JustifyPersist = values.justify;
    const rules: DiscountItemRuleRequest[] = DiscountItemRuleRequest.ofList(this.rules);
    rules.forEach((it) => it.discountType = this.selectedDiscountType);
    const contractDiscount: ContractDiscount = ContractDiscount.of({
      discountStrategy: this.contract.discountStrategy.value,
      discountType: this.selectedDiscountType,
      periodStart: this.periodStart,
      periodEnd: this.periodEnd,
      rules,
      justificationId: justify.justificationId,
      observation: justify.observation,
    });
    ContractService
      .saveDiscountConfig(this.businessUnitId, this.contract.id, contractDiscount)
      .then(() => {
        VbSnackbarService.showSuccess('Desconto(s) salvo(s) com sucesso');
        this.editModeValue = false;
        this.showJustityModal = false
      })
      .catch((err: any) => VbSnackbarService.handleHttpError(err))
  }

  cancel(): void {
    this.editModeValue = false;
  }
}
